import { createReducer } from '@reduxjs/toolkit';
import localesAction from '../actions/localesAction';

const initialState = 'en';
export default createReducer(initialState, (builder) => {
  builder.addCase(localesAction, (state, action) => action.payload);
});
